const Driver = () =>
  import(
    /* webpackChunkName: "system-setting-driver" */ '@/pages/system/setting/driver.vue'
  )

export default {
  path: 'driver',
  meta: {
    label: 'driver',
    auth: 'driver'
  },
  component: {
    name: 'Driver',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemSettingDriver',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Driver
    }
  ]
}
